import React from 'react';
import Email from '../Email';
import tools from '../../lib/tools';

export default function ProcessoFinalizadoOPS({ resp = {}, notify = false, print = false, viewHeader = false }) {

    const openURL = (error = false) => {
        return tools.openURL(`${resp.url}`);
    }

    return (
        <Email emailClass={`${print ? 'print-email' : 'email'}`}>
            <br />
            <br />
            <div className="w-100">
                <p className="text-center mt-30 mb-30 fb-18">PROCESSO FINALIZADO</p>
            </div>
            <p>Olá!</p>
            <p>Informamos que o processo ID {resp.protocolo} - {resp.beneficiario_nome} - {resp.beneficiario_guia} foi finalizado.</p>
            <p>Para consulta das informações e documentos relacionados ao processo, acesse a plataforma.</p>
            <br />
            <button className="btn btn-primary f700-16" onClick={openURL}>Visualizar processo</button>
            <br />
            <br />
            <div className="w-100 text-justify bold pb-50">
                <p>Atenciosamente,<br />
                    Equipe säästö.</p>
            </div>
        </Email>
    );
}